import React from "react";
import Hero from "../components/Hero";
import HowItWorks from "../components/sections/HowItWorks";
import CollectionPreview from "../components/sections/CollectionPreview";
import WhyAurevia from "../components/sections/WhyAurevia";
import ContactUs from "../components/sections/ContactUs";
import FinalCTA from "../components/sections/FinalCTA";
import { useSampleRequest } from "../context/SampleRequestContext";

export const Home = () => {
  const { openModal } = useSampleRequest();

  return (
    <main data-testid="home-page">
      <Hero />
      <HowItWorks />
      <CollectionPreview />
      <WhyAurevia />
      <ContactUs />
      <FinalCTA
        secondary={{
          label: "Request Free Samples",
          onClick: () => openModal([], "home_final_cta")
        }}
      />
    </main>
  );
};

export default Home;
